import { post } from '@/api/httpRequests'
import { getConfigRoute } from '@/api/apiConstants'
import Config from '../config'

export const getApiConfig = async () => {
    const apiConfig = await post(getConfigRoute)
    if (apiConfig) return new Config(apiConfig)
    return null
}
